import React, { FC, ReactElement } from 'react'
import { PartitionModal } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import FormRow from '../../Common/Components/FormRow'
import { ValidationErrors } from '../../Common/Components/ValidationErrors/ValidationErrors'
import { Rules } from '../../Common/Rules/Rules'
import { RouterCheckbox } from '../../../ReactRouting/Components/Atoms/Inputs/RouterCheckbox'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'
import { PartitionModalTelSysLayout } from '../Utils/partitionModalTelSysLayout'
import {
    PARTITION_CTI_LOG_ENABLED_FIELD_NAME,
    PARTITION_TRUNK_CAPACITY_BURST_FIELD_NAME,
    PARTITION_TRUNK_CAPACITY_FIELD_NAME
} from '../Constants/FieldNames'

type Props = {
    viewOnly?: boolean
    telSysLayout: PartitionModalTelSysLayout
}

/**
 * Advanced partition tab (CTI logging and optional trunking fields).
 *
 * @param props - Tab props.
 * @returns Advanced tab content.
 */
export const PartitionAdvancedTab: FC<Props> = ({ viewOnly, telSysLayout }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    const disabled: boolean = viewOnly ?? false
    let trunkPrimaryLabel: string = language.get(PartitionModal.PartitionModal_Advanced_Trunking)
    let trunkBurstLabel: string = language.get(PartitionModal.PartitionModal_Advanced_TrunkingBurst)

    if (telSysLayout.advancedTrunkLabelStyle === 'BROADSOFT_CAPACITY') {
        trunkPrimaryLabel = language.get(PartitionModal.PartitionModal_Advanced_TrunkingCapacity)
        trunkBurstLabel = language.get(PartitionModal.PartitionModal_Advanced_TrunkingCapacityBurst)
    }

    if (telSysLayout.advancedTrunkLabelStyle === 'WEBEX_CAPACITY') {
        trunkPrimaryLabel = language.get(PartitionModal.PartitionModal_Advanced_TrunkCapacity)
        trunkBurstLabel = language.get(PartitionModal.PartitionModal_Advanced_TrunkCapacityBurst)
    }

    return (
        <div className='partition-config-tab'>
            <FormRow>
                <RouterCheckbox
                    labelLeft={language.get(PartitionModal.PartitionModal_Advanced_CtiLoggingEnabled)}
                    name={PARTITION_CTI_LOG_ENABLED_FIELD_NAME}
                    disabled={disabled}
                />
            </FormRow>
            {telSysLayout.advancedShowTrunking ? (
                <>
                    <FormRow>
                        <ValidationErrors name={PARTITION_TRUNK_CAPACITY_FIELD_NAME}>
                            <OutlinedTextInput
                                labelLeft={trunkPrimaryLabel}
                                inputName={PARTITION_TRUNK_CAPACITY_FIELD_NAME}
                                disabled={disabled}
                                rules={{
                                    validate: {
                                        isNumber: Rules.isNumber(language)
                                    }
                                }}
                            />
                        </ValidationErrors>
                    </FormRow>
                    <FormRow>
                        <ValidationErrors name={PARTITION_TRUNK_CAPACITY_BURST_FIELD_NAME}>
                            <OutlinedTextInput
                                labelLeft={trunkBurstLabel}
                                inputName={PARTITION_TRUNK_CAPACITY_BURST_FIELD_NAME}
                                disabled={disabled}
                                rules={{
                                    validate: {
                                        isNumber: Rules.isNumber(language)
                                    }
                                }}
                            />
                        </ValidationErrors>
                    </FormRow>
                </>
            ) : (
                <></>
            )}
        </div>
    )
}
